export default __webpack_public_path__ + "440b1fd39e91e51e7522b7475338e338.png";